
    import { defineComponent, PropType } from 'vue'

    export default defineComponent({
        props: {
            route: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: true
            },
            params: {
                type: Object as PropType<Record<string, string>>
            }
        }
    })
